const SafetyClassificationFilter = {
  data() {
    return {
      activeSafetyClassifications: this.activeItems
    }
  },
  props: [
    'activeItems'
  ],
  watch: {
    activeItems(newValue) {
      this.activeSafetyClassifications = newValue
    }
  },
  methods: {
    handleInput: function(event) {
      bus.$emit('safetyClassification_filter', event.target.value)
    },
  }
}

export default SafetyClassificationFilter
